export default "__VITE_PUBLIC_ASSET__a701ff22__"